import React, { useState, useEffect, useContext } from "react";
import { useNavigate, NavLink } from "react-router-dom";
import { FunnelIcon } from "@heroicons/react/20/solid";
import { useMutation, useQuery } from "@apollo/client";
// import { toast } from "react-toastify";
import toast from "react-hot-toast";

import Filter from "./components/PreAuthFilter";
import PreAuthResponseModal from "./components/PreAuthResponseModal";
import gqlPreAuth from "../../gql/preAuth";
import DownloadExcel from "../../components/DownloadExcel";
import { appContext } from "../../context/ContextProvider";
import Pagination from "../../components/Pagination";
import PollBtn from "../../components/PollBtn";

import "./styles/pre-auth.css";
import "../Beneficiary/styles/BeneficiaryList.css";
import ConformationModal from "../../components/ConformationModal";
import AppModal from "../../components/AppModal";
import PreAuthJsonViewModal from "./PreAuthJsonViewModal";
import { BiSolidFileJson } from "react-icons/bi";
import { Badge, Chip, Tooltip } from "@mui/material";
import { TbEditCircle } from "react-icons/tb";
import { MdArrowCircleUp, MdOutlineRemoveRedEye, MdSync } from "react-icons/md";
import { BsFiletypeJson } from "react-icons/bs";
import Button from "@mui/material/Button";
import AddIcon from "@mui/icons-material/Add";
import FilterAltOutlinedIcon from "@mui/icons-material/FilterAltOutlined";
import ImportExportIcon from "@mui/icons-material/ImportExport";
import ConvertPreAuthToClaimModal from "./ConvertPreAuthToClaimModal";
import { CgArrowsExchangeAlt } from "react-icons/cg";
import { IoMdCloseCircleOutline } from "react-icons/io";
import { RiMessage2Line } from "react-icons/ri";
import claims from "../../gql/claims";
import { FaArrowUpFromBracket, FaRegCircleCheck } from "react-icons/fa6";
import ReplayIcon from "@mui/icons-material/Replay";
import PreAuthPbmModal from "./PreAuthPbmModal";
import { useTranslation } from "react-i18next";
import TableLoader from "../../common/TableLoader";
import TableSkeletonLoader from "../../common/TableLoading";
import RequestEligibilityModal from "../Eligibility/components/requestEligibility/RequestEligibilityModal";
import AppButton from "../../shared/AppButton";
import { FaFilter } from "react-icons/fa";
import AppTable from "../../shared/AppTable";

function PreAuthList(props) {
  const { t, i18n } = useTranslation();
  const { setShowLoader } = useContext(appContext);
  const navigate = useNavigate();
  const currentDate = new Date();
  const [loading, setLoading] = useState(false);
  const [openPbm, setOpenPbm] = useState(false);
  const [excelData, setExcelData] = useState([]);
  const [showFilters, setShowFilters] = useState(() => {
    const saved = sessionStorage.getItem("preAuthShowFilters");
    return saved !== null ? JSON.parse(saved) : true;
  });

  useEffect(() => {
    sessionStorage.setItem("preAuthShowFilters", JSON.stringify(showFilters));
  }, [showFilters]);
  const [item, setItem] = useState({});
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [showPreAuthResponseModal, setShowPreAuthResponseModal] =
    useState(false);
  const [showConvertToClaimModal, setShowConvertToClaimModal] = useState(false);
  const [showEligibilityModal, setShowEligibilityModal] = useState(false);
  const [errorData, setErrorData] = useState([]);
  const [open, setOpen] = useState(false);
  const [selectedItem, setSeelectedItem] = useState(null);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const fromDate = `${currentDate.getFullYear()}-${String(
    currentDate.getMonth() + 1,
  ).padStart(2, "0")}-01`;
  const toDate = `${currentDate.getFullYear()}-${String(
    currentDate.getMonth() + 1,
  ).padStart(2, "0")}-${new Date(
    currentDate.getFullYear(),
    currentDate.getMonth() + 1,
    0,
  ).getDate()}`;

  const [limit, setLimit] = useState(10);
  const [pageNo, setPageNo] = useState(1);

  const [preAuthFilters, setPreauthFilters] = useState(() => {
    const saved = sessionStorage.getItem("preAuthFiltersSaved");
    if (saved) {
      try {
        return JSON.parse(saved);
      } catch (e) {
        console.error("Failed to parse saved preAuth filters", e);
      }
    }
    return {
      from_date: fromDate,
      to_date: toDate,
      fromDateOrdered: "",
      toDateOrdered: "",
      payer_id: "",
      type: "",
      patient_id: "",
      from_date_ordered: "",
      to_date_ordered: "",
      status: "",
      pre_auth_ref_no: "",
      pre_auth_bundle_id: "",
      is_followup_req: false,
      limit: 10,
      page: 1,
    };
  });

  useEffect(() => {
    sessionStorage.setItem(
      "preAuthFiltersSaved",
      JSON.stringify(preAuthFilters),
    );
  }, [preAuthFilters]);

  const {
    loading: dataLoading,
    error,
    data,
    refetch,
  } = useQuery(gqlPreAuth.GET_PREAUTH_TRANSACTIONS, {
    variables: {
      input: {
        ...removeEmptyKeys(preAuthFilters),
      },
    },
  });

  useEffect(() => {
    if (error?.graphQLErrors[0]?.message) {
      toast.error(error?.graphQLErrors[0]?.message);
    }
  }, [error]);

  const {
    loading: excelDataLoading,
    error: excelDataError,
    data: excelDataResponse,
    refetch: refetchExcelDataResponse,
  } = useQuery(gqlPreAuth.GET_PREAUTH_EXCEL_DATA, {
    variables: {
      input: {
        from_date: fromDate,
        to_date: toDate,
      },
    },
    skip: true,
  });

  useEffect(() => {
    if (excelDataResponse) {
      setExcelData(
        JSON.parse(excelDataResponse?.listPreAuthTransactionsExcel?.data),
      );
    }
  }, [excelDataResponse]);

  const formatDateTime = (time) => {
    if (!time) return "";
    const sanitizedTime = time.replace(/\s\+\d{4}$/, "");
    const dateTime = new Date(sanitizedTime);
    if (isNaN(dateTime)) return "Invalid date";
    const dateOnly = dateTime.toLocaleDateString("en-GB");
    const timeOnly = dateTime.toLocaleTimeString(navigator.language, {
      hour: "2-digit",
      minute: "2-digit",
    });

    return `${dateOnly} </br> ${timeOnly}`;
  };

  const onDataRowClicked = (event, item) => {
    navigate("/preauth/details", { state: { currentItem: item } });
  };

  const onDataRowClickedCommunication = (event, item) => {
    navigate("/preauth/details", {
      state: { currentItem: item, tabToActive: "communications" },
    });
  };

  const onPageChange = async (currentPage) => {
    const payload = removeEmptyKeys(preAuthFilters);

    let filterInput = {
      ...payload,
      page: currentPage,
    };

    try {
      setLoading(true);
      await refetch({
        input: filterInput,
      });
    } finally {
      setLoading(false);
    }
    setPreauthFilters((prev) => ({
      ...prev,
      page: currentPage,
    }));
    /* localStorage.setItem('preAuthFilterDate', JSON.stringify(filterInput)); */
  };

  //cancel request
  const [
    cancelReq,
    { data: cancelData, loading: cancelLoading, error: cancelError },
  ] = useMutation(gqlPreAuth.CANCEL_REQUEST, {
    update(proxy, result) {
      onSuccessfulCancelRequestResponse(result.data);
    },
    onError(error) {
      onCancelResponseError(error.graphQLErrors[0]);
    },
  });

  const onSuccessfulCancelRequestResponse = (data) => {
    if (data.cancelRequest) {
      toast.success("Successfully Cancelled!");
    } else {
    }
  };

  const onCancelResponseError = (error) => {
    toast.error(`${error.message}`);
  };

  const cancelClicked = async () => {
    cancelReq({
      variables: {
        input: {
          transaction_id: selectedItem?.transaction_id,
          request_name: "preAuth",
        },
      },
    }).then(async (res) => {
      /*
      const preAuthFilterDate = JSON.parse(
        localStorage.getItem("preAuthFilterDate")
      );

      let filterInput = {
        ...preAuthFilterDate,
        page: pageNo,
        limit: limit,
      };

      // Remove empty keys from claimsFilterDate
      const filteredPreAuthFilterDate = removeEmptyKeys(filterInput);
      */

      const filteredPreAuthFilterDate = removeEmptyKeys({
        ...preAuthFilters,
        page: pageNo,
        limit: limit,
      });

      try {
        setLoading(true);
        await refetch({
          input: filteredPreAuthFilterDate,
        });
      } finally {
        setLoading(false);
      }
    });
    setShowConfirmModal(false);
    setSeelectedItem(null);
  };
  const getStatusStyles = (status) => {
    const s = status?.toLowerCase();
    if (s === "approved" || s === "complete" || s === "success") {
      return { bg: "#dcfce7", text: "#15803d" };
    } else if (s === "rejected" || s === "error" || s === "abnormal request") {
      return { bg: "#fee2e2", text: "#b91c1c" };
    } else if (s === "pending" || s === "queued" || s == "Validation Error") {
      return { bg: "#fef9c3", text: "#854d0e" };
    } else if (s === "pended" || s === "not-required") {
      return { bg: "#dbeafe", text: "#1d4ed8" };
    } else {
      return { bg: "#f1f5f9", text: "#475569" };
    }
  };

  const {
    loading: pollLoading,
    error: pollError,
    data: pollData,
    refetch: refetchPoll,
  } = useQuery(gqlPreAuth.PRE_AUTH_BULK_POLL_REQ, {
    skip: true, // Skip initial fetching
  });

  const {
    loading: communicationPollLoading,
    error: communicationPollError,
    data: communicationPollData,
    refetch: refetchCommunicationPoll,
  } = useQuery(gqlPreAuth.PRE_AUTH_COMMUNICATION_POLL, {
    skip: true, // Skip initial fetching
  });

  function removeEmptyKeys(obj) {
    const newObj = {};
    for (const key in obj) {
      if (obj[key] !== "") {
        newObj[key] = obj[key];
      }
    }
    return newObj;
  }

  const pollClicked = () => {
    toast.loading("Requesting!");
    refetchPoll().then(async (res) => {
      toast.success(res?.data?.pollRequest?.message || "Request Successfully!");

      refetchCommunicationPoll();

      /*
      const preAuthFilterDate = JSON.parse(
        localStorage.getItem("preAuthFilterDate")
      );

      let filterInput = {
        ...preAuthFilterDate,
        page: pageNo,
        limit: limit,
      };

      // Remove empty keys from claimsFilterDate
      const filteredPreAuthFilterDate = removeEmptyKeys(filterInput);
      */

      let filterInput = {
        ...preAuthFilters,
        page: pageNo,
        limit: limit,
      };

      const filteredPreAuthFilterDate = removeEmptyKeys(filterInput);

      try {
        setLoading(true);
        await refetch({
          input: filteredPreAuthFilterDate,
        });
      } finally {
        setLoading(false);
      }
    });
  };

  //check Status
  const [
    checkReq,
    { data: checkData, loading: checkLoading, error: checkError },
  ] = useMutation(claims.CHECK_STATUS, {
    update(proxy, result) {
      onSuccessfulCheckRequestResponse(result.data);
    },
    onError(error) {
      onCancelResponseError(error.graphQLErrors[0]);
    },
  });

  const onSuccessfulCheckRequestResponse = (data) => {
    if (!data.checkStatusRequest.nphies_err) {
      toast.success(
        data?.checkStatusRequest?.message || "Successfully Requested!",
      );
    } else if (data.checkStatusRequest.nphies_err) {
      // setErrorData(data.checkStatusRequest.nphies_err);
      // setShowErrorAlert(true);
    } else {
      toast.error(`Unknown Error`);
    }
  };

  const checkClicked = (item) => {
    toast.loading("Requesting!");
    checkReq({
      variables: {
        input: {
          transaction_id: item.transaction_id,
          request_name: "preAuth",
        },
      },
    });
  };
  const columns = [
    // --- Updated Status Column ---
    {
      header: t("Status"),
      render: (row) => {
        if (!row.status) return "---";
        const styles = getStatusStyles(row.status);
        return (
          <Chip
            label={row.status}
            size="small"
            sx={{
              backgroundColor: styles.bg,
              color: styles.text,
              fontWeight: "700",
              fontSize: "10px",
              borderRadius: "6px",
              textTransform: "uppercase",
              height: 20,
            }}
          />
        );
      },
    },
    // --- Updated Outcome Column ---
    {
      header: t("Outcome"),
      render: (row) => {
        if (!row.outcome) return "---";
        const styles = getStatusStyles(row.outcome);
        return (
          <Chip
            label={row.outcome}
            size="small"
            sx={{
              backgroundColor: styles.bg,
              color: styles.text,
              fontWeight: "700",
              fontSize: "10px",
              borderRadius: "6px",
              textTransform: "uppercase",
              height: 20,
            }}
          />
        );
      },
    },

    { header: t("Date Ordered"), field: "date_ordered" },
    { header: t("Response Id"), field: "pre_auth_ref_no" },
    {
      header: t("Beneficiary Name"),
      render: (row) => (
        <span className="capitalize font-medium text-gray-700 w-[220px] block whitespace-pre-wrap">
          {row?.patient_name || "---"}
        </span>
      ),
    },
    {
      header: t("Payer"),
      render: (row) => (
        <span className="text-gray-700 w-[220px] block whitespace-pre-wrap">
          {row?.payer_name || "---"}
        </span>
      ),
    },
    { header: t("Type"), field: "type" },
    {
      header: t("Response Date"),
      render: (row) => (
        <span
          dangerouslySetInnerHTML={{
            __html: formatDateTime(row.response_date),
          }}
        />
      ),
    },

    {
      header: t("Follow Up"),
      align: "center",
      render: (row) =>
        row?.is_followup_req ? (
          <Tooltip title={`${row?.followup_ref_transaction_id}`}>
            <div
              className="cursor-pointer text-blue-600 text-xl flex justify-center hover:scale-110 transition-transform"
              onClick={(e) => {
                e.stopPropagation();
                navigate(
                  "/preauth/details/" + row?.followup_ref_transaction_id,
                );
              }}
            >
              <MdArrowCircleUp />
            </div>
          </Tooltip>
        ) : (
          <span className="text-gray-400 text-xs">No</span>
        ),
    },
    {
      header: t("Referral"),
      align: "center",
      render: (row) => (
        <span
          className={`text-xs font-bold ${
            row?.is_referral ? "text-green-600" : "text-gray-400"
          }`}
        >
          {row?.is_referral ? t("Yes") : t("No")}
        </span>
      ),
    },
  ];

  return (
    <>
      <div class="pre_auth_container !p-0 ">
        <div className="flex justify-between items-start flex-col md:flex-row gap-1.5 mb-2">
          <div className="w-full sm:w-[calc(100%-150px)]">
            <span className="font-semibold text-black/70 text-lg ">
              {t("Pre-Auth Transactions")}
              <span className=" text-lg ml-1">
                ({data?.listPreAuthTransactions?.total || 0}{" "}
                <span className="text-xs font-bold italic">{t("Entries")}</span>
                )
              </span>
            </span>
          </div>
          <div className="w-full flex gap-1.5 flex-col md:flex-row justify-end ">
            <AppButton
              label={t("OCR")}
              onClick={() => {
                navigate("/ocr");
              }}
            />
            <AppButton label={t("PBM")} onClick={() => setOpenPbm(true)} />
            <AppButton
              label={t("Poll")}
              onClick={() => pollClicked()}
              startIcon={<ImportExportIcon />}
            />
            <AppButton
              label={t("Request Preauthorization")}
              onClick={() => navigate("/preauth/form")}
              startIcon={<AddIcon />}
            />
          </div>
        </div>
        <div className="bg-white border border-slate-200 rounded-lg p-2 mb-2">
          <Filter
            refetch={refetch}
            refetchExcelDataResponse={refetchExcelDataResponse}
            setLoading={setLoading}
            preAuthFilters={preAuthFilters}
            setPreauthFilters={setPreauthFilters}
            fromDate={fromDate}
            toDate={toDate}
          />
        </div>

        <AppTable
          columns={columns}
          data={data?.listPreAuthTransactions?.data}
          loading={loading || dataLoading}
          onView={(row) => onDataRowClicked(null, row)}
          bodyRowPadding="7px"
          containerClassName="custom-table-scrollbar"
          onEdit={(row) => navigate("/preauth/edit/form/" + row.transaction_id)}
          onJsonView={(row) => {
            setSeelectedItem(row);
            handleClickOpen();
          }}
          onCheck={(row) => checkClicked(row)}
          onConvert={(row) => {
            setSeelectedItem(row);
            setShowConvertToClaimModal(true);
          }}
          onCancel={(row) => {
            setSeelectedItem(row);
            setShowConfirmModal(true);
          }}
          onCommunication={(row) => onDataRowClickedCommunication(null, row)}
          onFollowUp={(row) =>
            navigate(`/preauth/edit/form/${row.transaction_id}/follow-up`)
          }
          LoaderComponent={
            <TableSkeletonLoader columnCount={11} rowCount={6} />
          }
        />
        <div>
          <Pagination
            currentPage={preAuthFilters.page}
            totalPages={data?.listPreAuthTransactions?.pages}
            onPageChange={onPageChange}
          />
        </div>
      </div>
      <PreAuthPbmModal setOpen={setOpenPbm} open={openPbm} />
      <ConformationModal
        open={showConfirmModal}
        setOpen={setShowConfirmModal}
        onDelete={() => cancelClicked(item)}
        text={"Cancel"}
      />
      <PreAuthJsonViewModal
        setOpen={setOpen}
        open={open}
        handleClose={handleClose}
        selectedItem={selectedItem}
      />
      <ConvertPreAuthToClaimModal
        showConvertToClaimModal={showConvertToClaimModal}
        setShowConvertToClaimModal={setShowConvertToClaimModal}
        selectedItem={selectedItem}
      />
    </>
  );
}

export default PreAuthList;
